module.exports = __webpack_public_path__ + "fonts/Flaticon.be935491.woff2";